import { CapAlertService } from '../../../core/extension/exceptions/cap-alert.service';
import {
  AvgeometergeschaeftService,
  GeometergeschaeftListEntryMeta,
  GeometergeschaeftNummerSearchRequest,
  GeometergeschaeftSearchResponse
} from '../../../core/av-api';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { TitleFunctionbarComponent } from '../../../shared/components/title-functionbar/title-functionbar.component';
import { FunctionbarSearchresultButtonsComponent } from '../../../shared/components/title-functionbar/functionbar-searchresult-buttons/functionbar-searchresult-buttons.component';
import { ListLoaderWrapperComponent } from '../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { Location, NgTemplateOutlet } from '@angular/common';
import { ColumnHeaderComponent } from '../../../shared/tablesort/sort-icon/column-header.component';
import { KompaktGeometergeschaeftComponent } from '../../../shared/kompaktdarstellung/geometergeschaeft/kompakt-geometergeschaeft.component';
import { LinkComponent, NavTarget } from '../../../shared/components/link/link.component';
import { KompaktAvMutationComponent } from '../../../shared/kompaktdarstellung/av-mutation/kompakt-av-mutation.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DatumPipe } from '../../../shared/pipes/simple/datum.pipe';
import { TableSortModel } from '../../../shared/tablesort/tableSortModel';
import { ListLoaderPreloaded } from '../../../shared/components/list-loader/list-loader-preloaded';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { ComparatorService } from '../../../shared/services/comparator-service';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { AppPermissionService } from '../../../core/services/app-permission.service';
import { keysToTranslate } from '../../../../i18n/keys-to-translate';
import { SearchMode } from '../../../shared/enum/searchMode';
import { geometergeschaeftSearchModeName } from '../geometergeschaeft.constants';
import { ErweiterungConfigResponse, PermissionResponse } from '../../../core/base-api';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;
import PermissionsEnum = PermissionResponse.PermissionsEnum;

@Component({
  selector: 'cap-geometergeschaeft-list',
  templateUrl: './geometergeschaeft-list.component.html',
  styleUrls: ['./geometergeschaeft-list.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    FunctionbarSearchresultButtonsComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    ColumnHeaderComponent,
    KompaktGeometergeschaeftComponent,
    LinkComponent,
    KompaktAvMutationComponent,
    TranslatePipe,
    DatumPipe
  ]
})
export class GeometergeschaeftListComponent implements OnInit, OnDestroy {
  navTargets = NavTarget;

  tableSortModel = new TableSortModel<GeometergeschaeftListEntryMeta>('table', this.comparatorService);
  geometergeschaeftListLoader: ListLoaderPreloaded<GeometergeschaeftListEntryMeta>;
  geometergeschaeftResponse: GeometergeschaeftSearchResponse;
  pageSize = 15;
  isAvPlusActive: boolean = false;
  isAvgbsActive: boolean = false;
  private subscription: Subscription;

  constructor(
    private geometergeschaeftService: AvgeometergeschaeftService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private capAlertService: CapAlertService,
    private location: Location,
    private stateService: SearchStateService,
    protected comparatorService: ComparatorService,
    private appFormatConfigService: FormatConfigService,
    private permissionService: AppPermissionService
  ) {
    keysToTranslate<string>([
      'Anmelder',
      'Dokumente',
      'Eingangsdatum',
      'Grundbuchgeschäft',
      'BereitfürGrundbuch',
      'Auftragsdatum',
      'AV-Mutation',
      'gefundeneGeometergeschaefte',
      'detailsGeometerGeschäft',
      'detailsMutationAnzeigen',
      'Geometergeschaeftszustand.EROEFFNET',
      'Geometergeschaeftszustand.BEARBEITUNG',
      'Geometergeschaeftszustand.BEREIT_ZUR_VERIFIKATION',
      'Geometergeschaeftszustand.WARTEN_AUF_VORGAENGER',
      'Geometergeschaeftszustand.BEREIT_FUER_GRUNDBUCH',
      'Geometergeschaeftszustand.RECHTSGUELTIG_VOLLZOGEN',
      'Geometergeschaeftszustand.RECHTSGUELTIG_ABGESCHLOSSEN',
      'Geometergeschaeftszustand.ZURUECK_ZUR_KORREKTUR',
      'Geometergeschaeftszustand.ZURUECK_ZURUECKGEZOGEN',
      'Geometergeschaeftszustand.ZURUECK_ABGEWIESEN',
      'Geometergeschaeftszustand.RUECKMUTIERT_ABGESCHLOSSEN',
      'Geometergeschaeftszustand.BEREIT_FUER_VERARBEITUNG',
      'Geometergeschaeftszustand.VERKNUEPFT_MIT_GRUNDBUCH',
      'Geometergeschaeftszustand.BEREIT_FUER_KORREKTURLIEFERUNG'
    ]);
    this.tableSortModel
      .addColumn('geometergeschaeft', (a, b) => comparatorService.geometergeschaeftComparator(a.geometergeschaeft, b.geometergeschaeft))
      .switchSortDirection();
    this.tableSortModel.addColumn('status', (a, b) => comparatorService.translatedStringComparator(a.status, b.status));
    this.tableSortModel.addColumn('avMutation', (a, b) => comparatorService.avMutationComparator(a.avMutation, b.avMutation));
    this.tableSortModel.addColumn('geoGeschaeftsArt', (a, b) =>
      comparatorService.translatedStringComparator(a.geoGeschaeftsArt, b.geoGeschaeftsArt)
    );
    this.tableSortModel.addColumn('verarbeitungsArt', (a, b) =>
      comparatorService.translatedStringComparator(a.verarbeitungsArt, b.verarbeitungsArt)
    );
    this.tableSortModel.addColumn('beschreibung', (a, b) => comparatorService.translatedStringComparator(a.beschreibung, b.beschreibung));
    this.tableSortModel.addColumn('auftragsDatum', (a, b) => comparatorService.dateComparator(a.auftragsDatum, b.auftragsDatum));
    this.tableSortModel.addColumn('abschlussDatum', (a, b) => comparatorService.dateComparator(a.abschlussDatum, b.abschlussDatum));
    this.tableSortModel.addColumn('bereitGBDatum', (a, b) => comparatorService.dateComparator(a.bereitGBDatum, b.bereitGBDatum));
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      const searchMode: SearchMode = params[geometergeschaeftSearchModeName];

      this.route.queryParams.subscribe((param) => {
        const request = JSON.parse(param['request']);
        this.stateService.lastSearchMode = searchMode;
        this.loadGeometerGeschaefte(request, searchMode);
      });
    });
    this.subscription.add(
      this.appFormatConfigService.erweiterungsConfig$.subscribe((erweiterungen) => {
        this.isAvPlusActive = erweiterungen.activeErweiterungen.includes(ActiveErweiterungenEnum.AV_PLUS);
        this.isAvgbsActive = erweiterungen.activeErweiterungen.includes(ActiveErweiterungenEnum.AVGBS);
      })
    );
  }

  isTableWithColumnMutation(): boolean {
    return this.isAvPlusActive || this.isAvgbsActive;
  }

  isTableWithColumnVerarbeitungsart(): boolean {
    return this.isAvPlusActive;
  }

  hasPermissionAnzeigeBeschreibung(): boolean {
    return this.permissionService.hasPermission(PermissionsEnum.ANZEIGE_BESCHREIBUNG_HAENGIGE_GESCHAEFTE);
  }

  navigateBackToSearch(): void {
    this.location.back();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private loadGeometerGeschaefte(request: GeometergeschaeftNummerSearchRequest, searchMode: SearchMode) {
    this.subscription = this.getGeometerGeschaeftListSubscription(request)[searchMode].subscribe({
      next: (response) => {
        this.loadGeometerGeschaeftFrom(response);
      },
      error: (err) => {
        this.handleError(err);
      }
    });
  }

  private handleError(err) {
    throw err;
  }

  private loadGeometerGeschaeftFrom(response) {
    this.geometergeschaeftResponse = response;
    if (response.recordsFound === 0) {
      this.capAlertService.info(this.translate.instant('KeineResultateGefunden'), undefined, true);
      this.navigateBackToSearch();
    }
    this.geometergeschaeftListLoader = new ListLoaderPreloaded<GeometergeschaeftListEntryMeta>(
      this.pageSize,
      1,
      response.results,
      response.recordsFound
    );
    this.geometergeschaeftListLoader.applySortModel(this.tableSortModel);
  }

  private getGeometerGeschaeftListSubscription(request) {
    return {
      searchStandard: this.geometergeschaeftService.searchGeometergeschaeftStandard(request)
    };
  }
}
